import {RichTextContent} from "./rich-text.content";
import {ListContent} from "./list.content";
import {PlayerListContent} from "./player-list.content";
import {TwoColumnContent} from "./two-column.content";
import {TransferContent} from "./transfers.content";
import {CMSContentType} from "../CMSType";
import {HeaderOneContent} from "../headers/header-one.content";
import {AContent} from "../base.content";
import {MapContent} from "./map.content";
import {GalleryContent} from "./gallery.content";
import {ImageListContent} from "./image-list.content";
import {DetailsContent} from "./details.content";
import {HeaderTwoContent} from "../headers/header-two.content"

export type InfoContent = RichTextContent | ListContent | TwoColumnContent | PlayerListContent | TransferContent;
export * from './list.content';
export * from './player-list.content';
export * from './rich-text.content';
export * from './transfers.content';
export * from './two-column.content';
export * from './details.content';

export function factoryCmsContent(name: CMSContentType, data: any): AContent {
  switch (name) {
    case CMSContentType.headerOne:
      return new HeaderOneContent(data);
    case CMSContentType.headerTwo:
      return new HeaderTwoContent(data);
    case CMSContentType.richText:
      return new RichTextContent(data);

    case CMSContentType.map:
      return new MapContent(data);
    case CMSContentType.gallery:
      return new GalleryContent(data);

    case CMSContentType.list:
      return new ListContent(data);
    case CMSContentType.imageList:
      return new ImageListContent(data);
    case CMSContentType.playerList:
      return new PlayerListContent(data);
    case CMSContentType.transfers:
      return new TransferContent(data);
    case CMSContentType.twoColumns:
      return new TwoColumnContent(data);

    case CMSContentType.details:
      return new DetailsContent(data);

    default:
      throw 'Undefined node type';
  }
}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/index.ts